const UNAVAILABLE = {
  EXPIRED: {
    message: "This invitation link has expired.",
    detail: "Ask the office for a new link and we’ll get you set up.",
  },
  CANCELLED: {
    message: "This invitation has been cancelled.",
    detail: "If you think this is a mistake, contact the office. They can invite you again.",
  },
  SUPERSEDED: {
    message: "This invitation link has been replaced.",
    detail: "We sent you a newer invitation email. Open the latest one and use the link in it.",
  },
};

const FALLBACK = "This invitation link is invalid or has expired.";

/**
 * Maps a failed onboarding call to what the wizard shows. A 410 means the link was real but is no
 * longer usable; the body says why. `terminal` tells the wizard to replace the form with the
 * message, since nothing the partner types can revive the link.
 */
export const describeInvitationError = (err) => {
  const response = err?.response;
  if (response?.status === 410) {
    const known = UNAVAILABLE[response.data?.reason] || UNAVAILABLE.EXPIRED;
    return { ...known, terminal: true };
  }
  return {
    message:
      response?.data?.errorMessage ||
      response?.data?.message ||
      (!response && err?.message) ||
      FALLBACK,
  };
};
